/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */

import {IProductShort} from 'modules/products/types';

export const computeMinMaxPrices = (list?: IProductShort[] | null) => {
    if (!list?.length) {
        return {minPrice: 0, maxPrice: 0};
    }

    const prices = list
        .map((product) => product.price?.discount?.price ?? product.price?.base?.price)
        .filter((value): value is number => 'number' === typeof value && Number.isFinite(value));

    if (!prices.length) {
        return {minPrice: 0, maxPrice: 0};
    }

    return {
        minPrice: Math.min(...prices),
        maxPrice: Math.max(...prices),
    };
};

export const buildProductsSchemaJson = (params: {
    products?: IProductShort[] | null;
    name?: string | null;
    description?: string | null;
    image?: string | null;
    offerCount?: number;
}) => {
    const {products, name, description, image, offerCount} = params;

    if (!products?.length) {
        return null;
    }

    const ratingValues: number[] = [];
    let ratingCountSum = 0;

    products.forEach((product) => {
        const reviewRating = product.ratings?.find((rating) => 'REVIEWS' === rating.code);
        if (reviewRating) {
            ratingValues.push(reviewRating.value);
            ratingCountSum += Number(product.reviewsCount || 0);
        }
    });

    const ratingValue = ratingValues.length
        ? Number((ratingValues.reduce((a, b) => a + b, 0) / ratingValues.length).toFixed(2))
        : undefined;

    const {minPrice, maxPrice} = computeMinMaxPrices(products);

    const json: Record<string, any> = {
        '@context': 'https://schema.org/',
        '@type': 'Product',
        name: name || '',
        image: image || undefined,
        description: description || undefined,
        offers: {
            '@type': 'AggregateOffer',
            priceCurrency: 'RUB',
            lowPrice: minPrice,
            highPrice: maxPrice,
            offerCount: offerCount || products.length,
        },
        aggregateRating:
            'number' === typeof ratingValue || ratingCountSum
                ? {
                      '@type': 'AggregateRating',
                      ratingValue,
                      ratingCount: ratingCountSum || undefined,
                      bestRating: 5,
                      worstRating: 1,
                  }
                : undefined,
    };
    return json;
};

// export const buildOfferCatalogSchemaJson = (params: {
//     products?: IProductShort[] | null;
//     name?: string | null;
//     description?: string | null;
//     pathname: string;
//     totalCount?: number;
// }) => {
//     const {products, name, description, pathname, totalCount} = params;
//
//     if (!products?.length) {
//         return null;
//     }
//
//     const offers = products.map((product) => {
//         const basePrice = product.price?.base?.price as number | undefined;
//         const discountPrice = product.price?.discount?.price as number | undefined;
//         const finalPrice = discountPrice || basePrice;
//
//         return {
//             '@type': 'Offer',
//             itemOffered: {
//                 '@type': 'Product',
//                 name: product.name || '',
//                 image: `${NEXT_PUBLIC_MASTER_HOST}${product.media?.imagePreview || ''}`,
//                 url: `${NEXT_PUBLIC_MASTER_HOST}${product.url || ''}`,
//                 description: product.description || undefined,
//                 sku: product.article || undefined,
//                 ...(finalPrice && {
//                     offers: {
//                         '@type': 'Offer',
//                         price: finalPrice,
//                         priceCurrency: product.price?.base?.currency || 'RUB',
//                         availability: product.canBuy ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock',
//                         url: `${NEXT_PUBLIC_MASTER_HOST}${product.url || ''}`,
//                         ...(basePrice &&
//                             discountPrice &&
//                             basePrice !== discountPrice && {
//                                 priceSpecification: {
//                                     '@type': 'PriceSpecification',
//                                     price: finalPrice,
//                                     priceCurrency: product.price?.base?.currency || 'RUB',
//                                     priceValidUntil: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000)
//                                         .toISOString()
//                                         .split('T')[0],
//                                 },
//                             }),
//                     },
//                 }),
//             },
//         };
//     });
//
//     const json: Record<string, any> = {
//         '@context': 'https://schema.org/',
//         '@type': 'OfferCatalog',
//         name: name || 'Каталог товаров',
//         description: description || undefined,
//         url: `${NEXT_PUBLIC_MASTER_HOST}${pathname}`,
//         numberOfItems: totalCount || products.length,
//         itemListElement: offers,
//     };
//
//     return json;
// };
